import * as React from 'react'

import { ApplicationForm } from './ApplicationForm'
import { BasicInformation } from './BasicInformation'
import { Description } from './Description'
import { EvaluationForms } from './EvaluationForms'
import { HiringPipeline } from './HiringPipeline'
import { HiringTeam } from './HiringTeam'
import { SmartActions } from './SmartActions'
import { Sections } from './types'

interface Props {
  selected: string
  jobId: number
  companyId: number
}

export const SectionComponent = ({ selected, jobId, companyId }: Props) => {
  switch (selected) {
    case Sections.BasicInfo:
      return <BasicInformation jobId={jobId} />
    case Sections.Description:
      return <Description jobId={jobId} />
    case Sections.ApplicationForm:
      return <ApplicationForm jobId={jobId} />
    case Sections.HiringPipeline:
      return <HiringPipeline jobId={jobId} />
    case Sections.HiringTeam:
      return <HiringTeam jobId={jobId} companyId={companyId} />
    case Sections.InternalEvaluationForms:
      return <EvaluationForms jobId={jobId} />
    case Sections.SmartActions:
      return <SmartActions jobId={jobId} />
    default:
      return <div>default - {jobId}</div>
  }
}
